export default __webpack_public_path__ + "static/media/management.3915bd22.png";